import {
  amountInfoReducer,
  billingInquiryDetailReducer,
  createBillingInquiryReducer,
  customerInfoListReducer,
  inquiryInboundInfoReducer,
  settlementReducer
} from './Settlement/settlementReducer';
import { combineReducers } from 'redux';
import inboundReducer, {
  approveInboundReducer,
  completeInboundReducer,
  detailInboundReducer
} from './inboundReducer/inboundReducers';
import inventoryReducer, {
  getIdSellerReducer
} from './inboundReducer/inventoryReducer';
import UserReducer from './inboundReducer/userReducer';
import {
  returnDisposalReducer,
  returnDisposalDetailReducer
} from './return_disposal/returnDisposalReducer';

import myAccountReducer from './myAccount/myAccountReducer';

const reducers = combineReducers({
  inboundReducer: inboundReducer,
  approveInboundReducer: approveInboundReducer,
  detailInboundReducer: detailInboundReducer,
  completeInboundReducer: completeInboundReducer,
  //inventory:
  inventoryReducer: inventoryReducer,
  getIdSellerReducer: getIdSellerReducer,
  userReducer: UserReducer,

  // return disposal
  returnDisposalReducer: returnDisposalReducer,
  returnDisposalDetailReducer: returnDisposalDetailReducer,

  //my account
  myAccountReducer: myAccountReducer,

  // settlement
  settlementReducer: settlementReducer,
  amountInfoReducer: amountInfoReducer,
  billingInquiryDetailReducer: billingInquiryDetailReducer,
  customerInfoListReducer: customerInfoListReducer,
  inquiryInboundInfoReducer: inquiryInboundInfoReducer,
  createBillingInquiryReducer: createBillingInquiryReducer
});

export default reducers;

export type RootState = ReturnType<typeof reducers>;
